export default "__VITE_ASSET__tTpIPFm8__"